export enum EJobType {
    User = 1,
    System = 2,
    Wait = 3,
    Alarm = 4
}